import React from 'react'

function AppTabs({data, selected}) {
  return (
    <div class="g-col-12 g-col-lg-8 g-col-xxl-9">
        {data.map((dataObj)=>{
            return(
                <div style={ dataObj.id === selected ? { display: "block" }
                : { display: "none" } }>
                    {dataObj.component}
                </div>
            )
        })}
    </div>
  )
}

export default AppTabs